import { call, put } from 'redux-saga/effects';
import ERRORS from 'constants/errors';
import STEPS from 'constants/steps';
import { createLogger } from 'helpers/logger';
import { setError, startLoading, stopLoading, setStep } from 'reduxConfig/auth.creators';

const log = createLogger('[auth-saga]');

export function* authVerifyEmail() {
  yield put(startLoading());
  try {
    // Reload the current user to get the latest state
    yield call(window.FIREBASE.reloadUser);
    // Check if email is verified
    const user = yield call(window.FIREBASE.user);
    if (user.emailVerified) {
      // Redirect to login if email is verified
      yield put(setStep(STEPS.verifyEmailComplete));
    } else yield put(setError(ERRORS.emailNotVerified));
  } catch (error) {
    log.info('Verify email error:', error); // eslint-disable-line
    // Dispatch a failure action to the store with the error
    yield put(setError(ERRORS.verifyEmail));
  } finally {
    yield put(stopLoading());
  }
}
